import React, { useReducer } from "react";
import { useMediaQueries } from "@layout/useMediaQueries";
import Timeline from "@components/Timeline/Timeline";

const RedistrictingStatus = ({
	events,
	statusText,
	statusHeading,
	timelineHeading,
}) => {
	const month = 2678400000;

	const mediaReducer = (state, action) => {
		switch (action) {
			case "mobile":
				return month * 2.5;
			case "mobile-large":
				return month * 1.5;
			case "desktop":
				return month * 2.5;
			case "widescreen":
				return month;
		}
	};

	const [groupBy, dispatch] = useReducer(mediaReducer, month);

	useMediaQueries(
		[
			["mobile", "(max-width: 560px)"],
			["mobile-large", "(min-width: 720px)"],
			["desktop", "(min-width: 960px)"],
			["widescreen", "(min-width: 1330px)"],
		],
		dispatch
	);

	return (
		<div>
			{statusHeading}
			{statusText}
			<Timeline
				groupBy={groupBy}
				events={events}
				heading={timelineHeading}
				iconMap={{
					Meeting: {
						icon: "People",
						color: "#0f38ff",
					},
					Milestone: {
						icon: "Diamond",
						color: "#da3b01",
					},
					Publication: {
						icon: "Documentation",
						color: "#ffbb00",
					},
				}}
			></Timeline>
		</div>
	);
};

export default RedistrictingStatus;
